import { render, staticRenderFns } from "./AdminDAHazardousForm.vue?vue&type=template&id=7c93bf74"
import script from "./AdminDAHazardousForm.vue?vue&type=script&lang=js"
export * from "./AdminDAHazardousForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports